import React, {useState, useRef, useEffect} from 'react'
import axios from 'axios'
import ReCAPTCHA from "react-google-recaptcha";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";
import { ReactSession } from 'react-client-session';

import {
    configBaseUrl
} from '../common/data'

const Registration = props => {

    const { env, devmode, sitekey, stripepublickey, preselectedValues } = props
    const stripePromise = loadStripe(stripepublickey);
    const defaultNoOfDays = 30

    ReactSession.setStoreType("localStorage");

    const [mySlides1, setMySlides1] = useState(true)
    const [mySlides2, setMySlides2] = useState(false)
    const [mySlides3, setMySlides3] = useState(false)
    const [planName, setPlanName] = useState('solo')
    const [trialDays, setTrialDays] = useState("30 Days")
    const [promoCodeText, setPromoCodeText] = useState('')
    const [promoCodeClass, setPromoCodeClass] = useState('')
    const [promoCodeSpanClass, setPromoSpanClass] = useState('')
    const [firstRegisterPage, setFirstRegisterPage] = useState(true)
    const [secondRegisterPage, setSecondRegisterPage] = useState(false)
    const [isRegisterSuccessFully, setIsRegisterSuccessFully] = useState(false)
    const [registeredEmail, setRegisteredEmail] = useState('')

    const [planPrice, setPlanPrice] = useState(99)
    const [planTitle, setPlanTitle] = useState('')
    const [planDescription, setPlanDescription] = useState('')
    const [planUsers, setPlanUsers] = useState(3)
    const [planProjects, setPlanProjects] = useState(1)
    const [planKeywords, setPlanKeywords] = useState(100)
    const [planAddresses, setPlanAddresses] = useState(50)
    const [planURLs, setPlanURLs] = useState(50)
    const [planCountry, setPlanCountry] = useState(5)
    const [planNatApps, setPlanNatApps] = useState(5)
    const [planNatKeywords, setPlanNatKeywords] = useState(5)

    const [planFrequency, setPlanFrequency] = useState("monthly")
    const [remainingDays, setRemainingDays] = useState(30)
    const [reminderDays, setReminderDays] = useState(27)
    const [expiryDays, setExpiryDays] = useState(29)
    const [renewalDate, setRenewalDate] = useState('')
    const [expiryDate, setExpiryDate] = useState('')
    const [reminderDate, setReminderDate] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [loadingSpinner, setLoadingSpinner] = useState(false)
    const [priceId, setPriceId] = useState('')
    const [planType, setPlanType] = useState("ALL_TOOL")

    let baseUrl = configBaseUrl[env]
    let publicUrl = configBaseUrl[env] + 'build/'
    const cannotUseDevMode = ['live','staging']
    if (!cannotUseDevMode.includes(env) && devmode === 'Y')
        baseUrl = baseUrl + 'app_dev.php/'

    ReactSession.set("planFrequency", planFrequency);
    ReactSession.set("planPrice", planPrice);
    ReactSession.set("planName", planName);
    ReactSession.set("trialDays", trialDays);
    ReactSession.set("priceId", priceId);
    ReactSession.set("baseUrl", baseUrl);

    const calculateDueDates = (days) => {
        const options = { day: 'numeric', month: 'long', year: 'numeric' };
        let today = new Date();
        today.setDate(today.getDate() + days);
        return new Date(today).toLocaleDateString("en", options);
    }

    const updateDatesWithPromo = () => {
        let dateThree = calculateDueDates(reminderDays);
        let dateSeven = calculateDueDates(remainingDays);
        let dueDate = calculateDueDates(expiryDays);
        setReminderDate(dateThree)
        setRenewalDate(dateSeven)
        setExpiryDate(dueDate)
        ReactSession.set("renewalDate", dateSeven);
        ReactSession.set("expiryDate", dueDate);
    }

    const handleslideClick = () => {
        if(mySlides1) {
            setMySlides1(false)
            setMySlides2(true)
            setMySlides3(false)
        }
        else if(mySlides2) {
            setMySlides1(false)
            setMySlides2(false)
            setMySlides3(true)
        }
        else {
            setMySlides1(true)
            setMySlides2(false)
            setMySlides3(false)
        }
    }

    const handleNextPage = () => {
        setFirstRegisterPage(false)
        setSecondRegisterPage(true)
    }

    const handlePrevPage = () => {
        setFirstRegisterPage(true)
        setSecondRegisterPage(false)
    }

    const checkPromoCode = (promoCode) => {
        setPromoCodeClass('')
        setPromoSpanClass('')
        setPromoCodeText('')
        let data = {'promoCode': promoCode}
        let textLength = promoCode.length

        if (textLength > 0) {
            axios.post(baseUrl + 'form-helpers/registration/validate-promo-code/', data)
                .then(r => {
                    if(r.data.success === true)
                    {
                        let noOfDays = r.data.noOfDays
                        setPromoCodeClass(' has-success')
                        setPromoSpanClass(' glyphicon-ok')
                        setPromoCodeText(r.data.message)
                        setTrialDays(r.data.message)
                        ReactSession.set("trialDays", r.data.message)
                        setRemainingDays(noOfDays)
                        setExpiryDays(noOfDays - 1)
                        setReminderDays(noOfDays - 4)
                    }
                    else {
                        setPromoCodeClass(' has-error has-danger')
                        setPromoSpanClass(' glyphicon-remove')
                        setPromoCodeText(r.data.message)
                        setTrialDays(defaultNoOfDays + ' Days')
                        ReactSession.set("trialDays", defaultNoOfDays + ' Days')
                        setRemainingDays(defaultNoOfDays)
                        setExpiryDays(defaultNoOfDays - 1)
                        setReminderDays(defaultNoOfDays - 4)
                    }
                })
        }
        else if (textLength === 0) {
            setPromoCodeClass('')
            setPromoSpanClass('')
            setPromoCodeText('')
            setTrialDays(defaultNoOfDays + ' Days')
            ReactSession.set("trialDays", defaultNoOfDays + ' Days')
            setRemainingDays(defaultNoOfDays)
            setExpiryDays(defaultNoOfDays - 1)
            setReminderDays(defaultNoOfDays - 4)

        }
    }

    useEffect(() => {
        updateDatesWithPromo()
    }, [expiryDays]);

    function onChange(value) {
        console.log('Captcha value:', value);
    }

    const registerFormSubmit = (event) => {
        event.preventDefault();
        setLoadingSpinner(true)
        var data = new FormData(event.target);
        let formObject = Object.fromEntries(data.entries())

        if(isRegisterSuccessFully && registeredEmail == formObject.sonata_user_registration_form_email) {
            handleNextPage()
        }
        else {
            axios.post(baseUrl + 'new-user-registration-process/', data)
                .then(r => {
                    setLoadingSpinner(false)
                    if( r.data.status == 'select-plan-frequency' )
                    {
                        setErrorMessage('')
                        handleNextPage()
                    }
                    else if( r.data.status == 'success' )
                    {
                        setIsRegisterSuccessFully(true)
                        setRegisteredEmail(r.data.registerEamil)
                        setErrorMessage('')
                        handleNextPage()
                    }
                    else if( r.data.status == 'error' )
                    {
                        setIsRegisterSuccessFully(false)
                        setErrorMessage(r.data.message)
                    }
                })
        }
    }

    setTimeout(function (){
        handleslideClick()
    }, 5000)

    useEffect(() => {
        let _preselectedValues = JSON.parse(preselectedValues)

        let _planName, _planType, _planFrequency
        if (_preselectedValues.plan)
            _planName = _preselectedValues.plan

        if (_preselectedValues.frequency)
            _planFrequency = _preselectedValues.frequency

        if (_preselectedValues.type) {
            switch( _preselectedValues.type ){
                case 'all' :
                    _planType = 'ALL_TOOL'
                    break;
                case 'serp' :
                    _planType = 'SERP_TOOL'
                    break;
                case 'page' :
                    _planType = 'PAGE_TOOL'
                    break;
                case 'app' :
                    _planType = 'APP_TOOL'
                    break;
                case 'lieve' :
                    _planType = 'LIVE_TOOL'
                    break;
            }
        }
        setPlanName(_planName)
        setPlanType(_planType)
        setPlanFrequency(_planFrequency)

        checkPlan(_planName, _planType)
        updateDatesWithPromo()
    }, []);

    const checkPlanRange = (planRange) => {
        console.log(planRange)
        setPlanFrequency(planRange)
        ReactSession.set("planFrequency", planRange);
        checkPlan(planName, planType, planRange)
        // if(planRange === 'Annually') {
        //     if(planName === 'solo') {
        //         checkPlanPrice(soloAnnuallyPrice)
        //     }
        //     else if(planName === 'pro') {
        //         checkPlanPrice(proAnnuallyPrice)
        //     }
        //     else if(planName === 'Agency') {
        //         checkPlanPrice(enterpriseAnnuallyPrice)
        //     }
        //     setSoloPriceId(soloAnnuallyPrice)
        //     setTeamPriceId(teamAnnuallyPrice)
        //     setProPriceId(proAnnuallyPrice)
        //     setEnterprisePriceId(enterpriseAnnuallyPrice)
        // }
        // else {
        //     if(planName === 'solo') {
        //         checkPlanPrice(soloMonthPrice)
        //     }
        //     else if(planName === 'pro') {
        //         checkPlanPrice(proMonthPrice)
        //     }
        //     else if(planName === 'Agency') {
        //         checkPlanPrice(enterpriseMonthPrice)
        //     }
        //     setSoloPriceId(soloMonthPrice)
        //     setTeamPriceId(teamMonthPrice)
        //     setProPriceId(proMonthPrice)
        //     setEnterprisePriceId(enterpriseMonthPrice)
        // }
    }

    // const checkPlanPrice = (planPriceId) => {
    //     setPriceId(planPriceId)
    //     ReactSession.set("priceId", planPriceId);
    // }

    const checkPlan = (plan, planType, planRange = "monthly") => {
        setPlanName(plan)
        setPlanType(planType)
        ReactSession.set("planName", plan);
        let data = {"planName": plan, "planFrequency": planRange, "planType": planType}
        axios.post(baseUrl + 'change-plan-feature-data', data)
            .then(r => {
                if(r.data.status == 'success')
                {
                    setPlanPrice(r.data.planPrice)
                    setPlanTitle(r.data.planName)
                    setPlanDescription(r.data.planDescription)
                    ReactSession.set("planPrice", r.data.planPrice);
                    setPlanUsers(r.data.planUsers)
                    setPlanProjects(r.data.planProjects)
                    setPlanKeywords(r.data.planKeywords)
                    setPlanAddresses(r.data.planAddresses)
                    setPlanURLs(r.data.planURLs)
                    setPlanCountry(r.data.planCountry)
                    setPlanNatApps(r.data.planNatApps)
                    setPlanNatKeywords(r.data.planNatKeywords)
                    setPriceId(r.data.priceId)
                    ReactSession.set("priceId", r.data.priceId);
                }
            })
    }
    return (
        <div className='Registration'>
            <div className="row">
                <div className="col-sm-12 col-sm-10 col-md-4">
                    <div className="try_free_text">
                        <h2><span className={"second-register-page " + (secondRegisterPage ? 'active' : 'inactive')} onClick={ () => handlePrevPage() }><i className="fa fa-regular fa-chevron-left" aria-hidden="true"></i></span>Try MobileMoxie for free</h2>
                        <span><i className="fa fa-check" aria-hidden="true"></i>Free 30 Days trial, cancel anytime</span>
                        <span><i className="fa fa-check" aria-hidden="true"></i>We'll remind you before your trial ends</span>
                    </div>

                    <div className={"social-register first-register-page " + (firstRegisterPage ? 'active' : 'inactive')}>
                        <a href={ baseUrl + 'connect/facebook' }
                           className="btn btn-default btn-facebook btn-social display_none">
                            <span className="fa-facebook-icon"></span> Sign up with Facebook
                        </a>
                        <a href={ baseUrl + 'connect/linkedin' }
                           className="btn btn-default btn-linkedin btn-social display_none">
                            <span className="fa-linkedin-icon"></span> Sign up with Linkedin
                        </a>
                        <a href={ baseUrl + 'connect/google' }
                           className="btn btn-default btn-google btn-social bg-white">
                            <span className="fa-google-icon"></span> Sign up with Google
                        </a>
                    </div>

                    <div className={"seperate-wrapper first-register-page " + (firstRegisterPage ? 'active' : 'inactive')}>
                        <div className="seperate-line"></div>
                        <span className="seperate-text">or</span>
                    </div>

                    <div className="text-center">
                        <div className={"uploadError" + (errorMessage ? "" : " hidden")}>
                            <div className="alert alert-error alert-icon">
                                <button type="button" className="close" data-dismiss="alert"><i className="material-icons">clear</i></button>
                                <table>
                                    <tr>
                                        <td><i className="material-icons">report_problem</i></td>
                                        <td>{errorMessage}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <form id="register_form_main" name="register_form_main" data-toggle="validator" onSubmit={registerFormSubmit}>
                            <input type="hidden" id="sonata_user_registration_form_demoAccountClientId" name="demoAccountClientId" value=""/>
                            <div className={"first-register-page " + (firstRegisterPage ? 'active' : 'inactive')}>
                                <div className="form-group custom-form-group has-feedback has-error has-danger">
                                    <input type="email" id="sonata_user_registration_form_email" name="sonata_user_registration_form_email" required="required" className="form-control" placeholder="Email (required)" data-error="Please enter a valid email address" />
                                    <span class="glyphicon form-control-feedback" aria-hidden="true"></span>
                                    <div class="help-block with-errors"></div>
                                </div>
                                <div className="row no-gutter">
                                    <div className="col-md-6 small-gutter">
                                        <div className="form-group custom-form-group has-feedback">
                                            <input type="text" id="sonata_user_registration_form_firstname" name="sonata_user_registration_form[firstname]" required="required" maxLength="64" className="form-control" placeholder="First Name (required)" />
                                            <span className="glyphicon form-control-feedback" aria-hidden="true"></span>
                                        </div>
                                    </div>
                                    <div className="col-md-6 small-gutter">
                                        <div className="form-group custom-form-group has-feedback">
                                            <input type="text" id="sonata_user_registration_form_lastname" name="sonata_user_registration_form[lastname]" required="required" maxLength="64" className="form-control" placeholder="Last Name (required)" />
                                            <span className="glyphicon form-control-feedback" aria-hidden="true"></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group custom-form-group has-feedback">
                                    <input type="text" id="sonata_user_registration_form_company" name="sonata_user_registration_form[company]" required="required" maxLength="255" className="form-control" placeholder="Company (required)" />
                                    <span className="glyphicon form-control-feedback" aria-hidden="true"></span>
                                </div>

                                <div className="form-group custom-form-group has-feedback">
                                    <input type="password" id="sonata_user_registration_form_plainPassword_first"  name="sonata_user_registration_form[plainPassword][first]" required="required" autoComplete="new-password" className="form-control" placeholder="Password (required)" data-minlength="6" data-error="Please enter minimum 6 characters" />
                                    <span className="glyphicon form-control-feedback" aria-hidden="true"></span>
                                    <div className="help-block with-errors"></div>
                                </div>

                                <div className="form-group custom-form-group has-feedback">
                                    <input type="password" id="sonata_user_registration_form_plainPassword_second" name="sonata_user_registration_form[plainPassword][second]" required="required" autoComplete="new-password" className="form-control" placeholder="Confirm Password (required)" data-match="#sonata_user_registration_form_plainPassword_first" data-error="Please enter a matching password" />
                                    <span className="glyphicon form-control-feedback" aria-hidden="true"/>
                                    <div className="help-block with-errors"/>
                                </div>

                                <div className={"form-group custom-form-group" + promoCodeClass} style={{"position": "relative"}}>
                                    <input type="text" id="sonata_user_registration_form_promoCode" name="sonata_user_registration_form[promoCode]" className="form-control" placeholder="Promo Code (optional)" autoComplete="off" onKeyUp={(e) => checkPromoCode(e.target.value)} onBlur={(e) => checkPromoCode(e.target.value)} />
                                    <span className={"glyphicon form-control-feedback"  + promoCodeSpanClass} aria-hidden="true"/>
                                    <div className="help-block with-errors">{ promoCodeText }</div>
                                </div>

                                <div className="form-group custom-form-group has-feedback">
                                    <textarea id="sonata_user_registration_form_signupNotes" name="sonata_user_registration_form[signupNotes]" className="form-control" rows="4" placeholder="If you plan to use MobileMoxie for a specific project, we would love to hear about it here."/>
                                    <span className="glyphicon form-control-feedback" aria-hidden="true"></span>
                                    <div className="help-block with-errors"></div>
                                </div>

                                <div class="form-group has-feedback">
                                    <div class="checkbox">
                                        <label class="custom-checkbox">
                                            By Registering, I accept the <a href="https://www.mobilemoxie.com/terms/" title="View our terms and conditions (will open in a new browser tab/window)" target="_blank" class="condition-link">Terms and Conditions</a> of use for the MobileMoxie Toolset and APIs.
                                            <div class="help-block with-errors"></div>
                                        </label>
                                    </div>
                                </div>
                                <div className="form-group has-feedback" style={{"width":'304px', "margin": '0 auto'}}>
                                    <ReCAPTCHA sitekey={sitekey} onChange={onChange}/>
                                </div>
                                <input type="hidden" name="_csrf_token_register" id="_csrf_token_register" />

                                <div class="form-actions">
                                    <div className={loadingSpinner ? "hidden" : ""}>
                                        <br />
                                        <input id='submit' type="submit" value="Next" className={"registrationFormSubmitBtn2 btn btn-register-blue blue_bg disabled" + (errorMessage ? "" : " disabled")}/>
                                    </div>
                                    <div className={loadingSpinner ? "" : "hidden"}>
                                        <br />
                                        <button className="btn btn-register-blue" id="startMyFreeTrialBtn"><i className="fa fa-spinner fa-spin" style={{"margin-left": "-12px", "margin-right": "8px"}}></i>Next</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <form id="register_form_plan_payment" name="register_form_plan_payment" data-toggle="validator" onSubmit={registerFormSubmit}>

                            <div className={"second-register-page " + (secondRegisterPage ? 'active' : 'inactive')}>
                                <div className={"payment-block"}>
                                    <div className={"form-group custom-form-group btn-group clean-radio-btn-group"}>
                                        <label className={'btn btn-default' + (planFrequency === 'monthly' ? ' active focus' : '')}>
                                            <input type="radio" name="planFrequency" value="monthly" onClick={(e) => checkPlanRange(e.target.value)} checked={planFrequency === 'monthly'} />Monthly
                                        </label>
                                        <label className={'btn btn-default' + (planFrequency === 'annually' ? ' active focus' : '')}>
                                            <input type="radio" name="planFrequency" value="annually" onClick={(e) => checkPlanRange(e.target.value)} checked={planFrequency === 'annually'} />Annually
                                        </label>
                                    </div>
                                </div>
                                <div className={"payment-block"}>
                                    <div className={"form-group custom-form-group btn-group clean-radio-btn-group"}>
                                        <label className={'btn btn-default' + (planName === 'solo' ? ' active focus' : '')}>
                                            <input type="radio" name="planName" value="solo" onClick={(e) => { checkPlan(e.target.value, planType, planFrequency);}} checked={planName === 'solo'} />Solo
                                        </label>
                                        <label className={'btn btn-default' + (planName === 'pro' ? ' active focus' : '')}>
                                            <input type="radio" name="planName" value="pro" onClick={(e) => {checkPlan(e.target.value, planType, planFrequency);}} checked={planName === 'pro'} />Pro
                                        </label>
                                        <label className={'btn btn-default' + (planName === 'agency' ? ' active focus' : '')}>
                                            <input type="radio" name="planName" value="agency" onClick={(e) => {checkPlan(e.target.value, planType, planFrequency);}} checked={planName === 'agency'} />Agency
                                        </label>
                                    </div>
                                </div>
                                <div className={"payment-block"}>
                                    <div className={"form-group custom-form-group btn-group clean-radio-btn-group multi-radio-btn-group"}>
                                        <label className={'btn btn-default' + (planType === 'ALL_TOOL' ? ' active focus' : '')}>
                                            <input type="radio" name="planType" value="ALL_TOOL" onClick={(e) => { checkPlan(planName, e.target.value, planFrequency);}} checked={planType === 'ALL_TOOL'} />All Tools
                                        </label>
                                        <label className={'btn btn-default' + (planType === 'SERP_TOOL' ? ' active focus' : '')}>
                                            <input type="radio" name="planType" value="SERP_TOOL" onClick={(e) => {checkPlan(planName, e.target.value, planFrequency);}} checked={planType === 'SERP_TOOL'} />SERP Tools
                                        </label>
                                        <label className={'btn btn-default' + (planType === 'PAGE_TOOL' ? ' active focus' : '')}>
                                            <input type="radio" name="planType" value="PAGE_TOOL" onClick={(e) => { checkPlan(planName, e.target.value, planFrequency);}} checked={planType === 'PAGE_TOOL'} />Page Tools
                                        </label>
                                        <label className={'btn btn-default' + (planType === 'APP_TOOL' ? ' active focus' : '')}>
                                            <input type="radio" name="planType" value="APP_TOOL" onClick={(e) => { checkPlan(planName, e.target.value, planFrequency);}} checked={planType === 'APP_TOOL'} />App Tools
                                        </label>
                                    </div>
                                </div>
                                <div className={"payment-block"}>
                                    <div className={"row"}>
                                        <div className={"col-md-6"}>
                                            <h3>{ planTitle } - ${ planPrice }</h3>
                                        </div>
                                        <div className={"col-md-6"}/>
                                    </div>
                                    <div className={"row"}>
                                        <div className={"col-md-4"}>
                                            <p>Users: { planUsers }</p>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <p>Projects: { planProjects }</p>
                                        </div>
                                    </div>
                                    { (planType === 'ALL_TOOL' || planType ==='SERP_TOOL') && (
                                    <div className={"row"}>
                                        { planType === 'ALL_TOOL' && (
                                        <div className={"col-md-12 product-title"}>
                                            <p><strong>SERP Tools</strong></p>
                                        </div>
                                        )}
                                        <div className={"col-md-4"}>
                                            <p>Keywords: { planKeywords }</p>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <p>Addresses: { planAddresses }</p>
                                        </div>
                                    </div>
                                    )}
                                    { (planType === 'ALL_TOOL' || planType ==='PAGE_TOOL') && (
                                    <div className={"row"}>
                                        { planType === 'ALL_TOOL' && (
                                            <div className={"col-md-12 product-title"}>
                                                <p><strong>Page Tools</strong></p>
                                            </div>
                                        )}
                                        <div className={"col-md-4"}>
                                            <p>URLs: { planURLs }</p>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <p>Countries: { planCountry }</p>
                                        </div>
                                    </div>
                                    )}
                                    { (planType === 'ALL_TOOL' || planType ==='APP_TOOL') && (
                                    <div className={"row"}>
                                        { planType === 'ALL_TOOL' && (
                                            <div className={"col-md-12 product-title"}>
                                                <p><strong>App Tools</strong></p>
                                            </div>
                                        )}
                                        <div className={"col-md-4"}>
                                            <p>Apps: { planNatApps }</p>
                                        </div>
                                        <div className={"col-md-4"}>
                                            <p>Keywords: { planNatKeywords }</p>
                                        </div>
                                        <div className={"col-md-4"}/>
                                    </div>
                                    )}
                                </div>
                                <div>
                                    <Elements stripe={stripePromise} expiryDate={expiryDate}>
                                        <CheckoutForm expiryDate={expiryDate} planFrequency={planFrequency} planName={planName} planPrice={planPrice} renewalDate={renewalDate} />
                                    </Elements>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div className="col-sm-12 col-sm-10 col-md-8">
                    <div className="try_free_right">
                        <div className="free_trial_box">
                            <div className="history-tl-container">
                                <ul className="tl">
                                    <li className="tl-item active" ng-repeat="item in retailer_history">
                                        <div className="free_step">
                                            <h2>Today - Free trial for {trialDays}. Cancel anytime</h2>
                                            <p className={secondRegisterPage ? 'hidden' : ''}>Start your free MobileMoxie trial and get access to ALL our tools and features.</p>
                                            <p className={secondRegisterPage ? '' : 'hidden'}>{planDescription}</p>
                                        </div>
                                    </li>
                                    <li className="tl-item bell hidden" ng-repeat="item in retailer_history">
                                        <div className="free_step">
                                            <h2>{reminderDate}</h2>
                                            <p>We'll send you a reminder 3 days before your MobileMoxie trial ends.</p>
                                        </div>
                                    </li>
                                    <li className="tl-item crown" ng-repeat="item in retailer_history">
                                        <div className="free_step">
                                            <h2>{renewalDate}</h2>
                                            <p>Your subscription starts, unless you've cancelled during the trial.</p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="testim">
                            <div className={"slide mySlide " + (mySlides1 ? 'active' : 'inactive')}>
                                <img src={publicUrl + 'img/testimonial1.png'} className="img-responsive"/>
                                <p>“I have used the SERPerator in two ways to make my life easier: 1) Pitching and winning new business from a medical client with clinics all over the country. By showing exactly what was happening in the SERPs per city I had a credible plan of attack that blew the competition out of the water 2) Accurate rank tracking reporting for a global finance client that reduced the “it’s not what I see on my phone” emails to zero”</p>
                            </div>
                            <div className={"slide mySlide " + (mySlides2 ? 'active' : 'inactive')}>
                                <img src={publicUrl + 'img/testimonial2.png'} className="img-responsive"/>
                                <p>“MobileMoxie is for me an irreplaceable part of my Local SEO digital marketing toolkit and I feel like I have barely scraped the surface on what it can do. The SERPetrator gives me the ability to replicate searches by zip code – it’s been invaluable in terms of illustrating to clients that what THEY see isn’t what their customer or their potential customers sees! MobileMoxie gives me the ability to track keywords that I want to test over time, at a range of locations, and combines this with kick arse visuals that I can use to add to customer reports, or to my presentations. I’m still learning all the things I can do with it, but I wouldn’t be without it!”</p>
                            </div>
                            <div className={"slide mySlide " + (mySlides3 ? 'active' : 'inactive')}>
                                <img src={publicUrl + 'img/testimonial3.png'} className="img-responsive"/>
                                <p>“I’ve been a MobileMoxie subscriber for a few years, after testing out the free version. It didn’t take long to upgrade and I’ve been a loyal user ever since. It’s my go-to mobile testing tool, and best of all (IMO) it’s awesome to either spot checking SERP pages in different locations, or tracking them over time. In short … worth every penny and then some.”</p>
                            </div>
                        </div>

                        <div className={secondRegisterPage ? '' : 'hidden'}>
                            <p className='hidden'>{planDescription}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Registration